export const _LOAD_MODEL_ = 'Load:ProductModel';
export const _RELOAD_TYPE_ = 'Reload:ProductType';
export const _LOAD_EQUIPMENT_ = 'Load:Equipment';
export const _RELOAD_EQUIPMENT_ = 'Reload:Equipment';

export const _DELETE_PRODUCT_ = 'Delete:Product';
export const _DELETE_PRODUCT_EQUIPMENT_ = 'Delete:Equipment';

export const _SAVE_PRODUCT_SUCCESS_ = 'Save:ProductSuccess';

export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';

export const PRODUCT_TYPE_OPTIONS = {
  id: null,
  slug: null,
  name: null,
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  price: null,
  type_id: 1,
  equipments: [],
};
